import { configureStore } from "@reduxjs/toolkit";
import  userReducer  from "./slices/userSlice.js";
import  pdfReducer  from "./slices/pdfSlice.js";
import themeReducer from "./slices/themeSlice.js";

export const store = configureStore({
  reducer: {
    userInfo: userReducer,
    pdfData:pdfReducer,
    theme: themeReducer,
  },
});
